<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    custom-class="dialog-short-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div v-loading="isLoading">
      <form-fleets-company
        :disabled="disabled"
        :data="data"
        :model="formModel"
        @updateModelItem="handlerUpdateModelItem"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        :isBack="isAvailableToSave"
        :isCancel="!isAvailableToSave"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew && !disabled"
        :isDelete="hasCreateNew && !disabled"
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import TabEditorWrap from '../TabEditorWrap'

export default {
  name: 'EditorFleets',
  mixins: [FormWrapperAutoSave, FormWrapper, TabEditorWrap],
  components: {
    'form-fleets-company': () => import(/* webpackChunkName: 'Companies' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object },
    companyID: { required: true }
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'Fleets/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.engine || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    },
    formModel () {
      return {
        id: null,
        engine: '',
        regionID: null,
        aircraftID: null,
        unit: ''
      }
    }
  }
}
</script>
